import { render, staticRenderFns } from "./screening-statistics-dialog.vue?vue&type=template&id=a0b7383c&scoped=true"
import script from "./screening-statistics-dialog.vue?vue&type=script&lang=js"
export * from "./screening-statistics-dialog.vue?vue&type=script&lang=js"
import style0 from "./screening-statistics-dialog.vue?vue&type=style&index=0&id=a0b7383c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b7383c",
  null
  
)

export default component.exports